import React from 'react';
import PropTypes from 'prop-types';
import './style.less';

class Mask extends React.PureComponent {
  static propTypes = {
    hide: PropTypes.func,
    cloneName: PropTypes.string,
  };

  static defaultProps = {
    cloneName: '',
  }

  componentDidMount() {
    setTimeout(() => {
      if (this.props.cloneName !== '') {
        const content = document.querySelector(this.props.cloneName);
        const duplicate = content.cloneNode(true);
        const modalBlur = document.createElement('div');
        modalBlur.className = 'modal-blur';
        modalBlur.appendChild(duplicate);
        const modal = document.querySelector('.modal');
        modal.appendChild(modalBlur);
        modal.addEventListener('click', (e) => {
          this.handleHideModal(e);
        });
      }
    }, 0);
  }

  handleHideModal = (e) => {
    e.preventDefault();
    this.props.hide && this.props.hide(e);
  };

  render() {
    return (
      <div>
        <div className="modal" id="modal" onClick={this.handleHideModal} />
        <svg id="svg-image-blur" className="svg-image-blur">
          <filter id="blur-effect">
            <feGaussianBlur stdDeviation="10" />
          </filter>
        </svg>
      </div>
    );
  }
}

export default Mask;
